import React from 'react'
import ReactDOM from 'react-dom'
import { Route } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { Provider } from 'react-redux'
import { store, history } from 'store/store'
import { I18nextProvider } from "react-i18next"
import i18n from "./i18n"
import Initializer from "screens/Initializer"
import MainPage from 'screens/MainPage'
import ErrorCatcher from 'components/ErrorCatcher'

console.log(`${process.env.REACT_APP_NAME} version ${process.env.REACT_APP_VERSION}`)


const target = document.querySelector('#root')

ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <ConnectedRouter history={history}>
        <Route
          render={props => (
              <ErrorCatcher {...props} >
                <Initializer {...props}>
                  <MainPage {...props} />
                </Initializer>
              </ErrorCatcher>
          )}
        />
      </ConnectedRouter>
    </I18nextProvider>
  </Provider>,
  target
)
